import { userConstants } from './../constants/user.constants';

const initialState = {};

export function callRegdetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.CALLREG_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.CALLREG_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.CALLREG_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}